import React, { useState } from 'react';
import {
  Box,
  Avatar,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Photo as PhotoIcon,
  Person as PersonIcon,
} from '@mui/icons-material';

interface SingleImageDisplayProps {
  image?: string;
  size?: number;
  title?: string;
  showPlaceholder?: boolean;
  placeholderIcon?: React.ReactNode;
  placeholderText?: string;
}

const SingleImageDisplay: React.FC<SingleImageDisplayProps> = ({
  image = '',
  size = 32,
  title = 'Фото',
  showPlaceholder = true,
  placeholderIcon = <PersonIcon />,
  placeholderText = 'Немає фото'
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleImageClick = () => {
    if (image) {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (!image && !showPlaceholder) {
    return null;
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {image ? (
          <Tooltip title={title}>
            <Avatar
              src={image}
              sx={{ 
                width: size, 
                height: size, 
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                  transform: 'scale(1.05)',
                  transition: 'all 0.2s ease-in-out'
                }
              }}
              onClick={handleImageClick}
            >
              <PhotoIcon />
            </Avatar>
          </Tooltip>
        ) : (
          <Chip 
            label={placeholderText} 
            size="small" 
            variant="outlined" 
            sx={{ color: 'text.disabled' }}
            avatar={
              <Avatar sx={{ width: 16, height: 16 }}>
                {placeholderIcon}
              </Avatar>
            }
          />
        )}
      </Box>

      {/* Діалог для перегляду фото */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">
              {title}
            </Typography>
            <IconButton onClick={handleCloseDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={image}
              alt={title}
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain'
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SingleImageDisplay;
